var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',[_c('conformidade',{attrs:{"paramInstituicaoId":_vm.$route.params.instituicao_id,"paramData":_vm.$route.params.data}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }